import Link from "next/link";

const localSearchLinks = [
  { href: "/coworking-paris-9", label: "Coworking Paris 9" },
  { href: "/coworking-gare-du-nord", label: "Coworking Gare du Nord" },
  { href: "/coworking-paris-nord", label: "Coworking Paris Nord" },
];

export const LocalSearchSection = () => {
  return (
    <section className="px-4 pb-10 pt-2 sm:px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-32">
      <div className="rounded-2xl border border-black/10 bg-white/70 p-4 text-black sm:p-6">
        <p className="text-sm font-semibold uppercase tracking-[0.14em] text-primary">
          Recherches locales
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          {localSearchLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="rounded-full border border-primary px-3 py-1.5 text-sm text-primary transition-colors hover:bg-primary hover:text-white"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
